import React, { useEffect, useState } from 'react'
import { useParams, NavLink } from 'react-router-dom'
import { getNotifications } from '../../utils/data';
import { client } from '../../client';

const Notifications = ({ setView, notifications, setNotifications }) => {
  // const [notifications, setNotifications] = useState();
  const [notFlag, setNotFlag] = useState();
  const { userId } = useParams();
  setView("Notifications");

  useEffect(() => {
    const query = getNotifications(userId);
    client.fetch(query).then((data) => {
      setNotifications(data[0].notifications);
    });
  }, [notFlag, userId])

  const removeNotification = (notKey) => {
    console.log("notification seen");
    console.log(notKey);

    client
      .patch(userId)
      .unset(['notifications[_key=="' + notKey + '"]'])
      .commit()
      .then((res) => {
        console.log(res);
        setNotFlag(true);
      });
  }

  return (
    <div className="flex flex-col bg-white h-full overflow-y-scroll min-w-210 hide-scrollbar">
      {notifications?.map((notification) =>
        <div className='flex mt-5 bg-secondaryColor items-center justify-between px-2 gap-3'>
          <NavLink
            to={notification.type === 'pin' ? `/pin-detail/${notification?.postId}` : (notification.type === 'vid' ? `/vid-detail/${notification?.postId}` : `/conversation-detail/${notification?.postId}`)}
            className='flex items-center px-5 gap-3 text-gray-500 hover:text-black transition-all duration-200 ease-in-out capitalize'
            key={notification?.commenter.userName}
            onClick={(e) => {removeNotification(notification._key)}}
          >
            <div className='flex flex-col'>
              <div className='flex flex-row items-center'>
                <img src={notification?.commenter?.image + "?h=40"} className="w-8 h-8 rounded-full shadow-sm" />
                <h1 className='pl-2 font-bold text-black'>{notification?.commenter.userName}</h1>
              </div>
              <p>{notification?.message}</p>
            </div>
          </NavLink>
        </div>
      )}
    </div>
  )
}

export default Notifications